<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-toc" id="table-of-contents">
<div class="heading heading-container-single heading-size-small heading-format-reduced heading-alignment-fixed heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">CONTENTS</h1>
</div>
</div>
</div>
</div>
<div class="toc-contents text">
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/prologuemia"><span class="toc-item-title-text">Prologue - Mia</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">1. </span><a href="#/chapter001"><span class="toc-item-title-text">Mia</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">2. </span><a href="#/chapter002"><span class="toc-item-title-text">Thac (Tlaloc)</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">3. </span><a href="#/chapter003"><span class="toc-item-title-text">Caleb</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">4. </span><a href="#/chapter004"><span class="toc-item-title-text">Mia</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">5. </span><a href="#/chapter005"><span class="toc-item-title-text">Thac</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">6. </span><a href="#/chapter006"><span class="toc-item-title-text">Caleb</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">7. </span><a href="#/chapter007"><span class="toc-item-title-text">Mia</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">8. </span><a href="#/chapter008"><span class="toc-item-title-text">Caleb</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">9. </span><a href="#/chapter009"><span class="toc-item-title-text">Thac</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">10. </span><a href="#/chapter010"><span class="toc-item-title-text">Mia</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">11. </span><a href="#/chapter011"><span class="toc-item-title-text">Mia</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">12. </span><a href="#/chapter012"><span class="toc-item-title-text">Thac</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">13. </span><a href="#/chapter013"><span class="toc-item-title-text">Caleb</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">14. </span><a href="#/chapter014"><span class="toc-item-title-text">Mia</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">15. </span><a href="#/chapter015"><span class="toc-item-title-text">Thac</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">16. </span><a href="#/chapter016"><span class="toc-item-title-text">Thac</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">17. </span><a href="#/chapter017"><span class="toc-item-title-text">Mia</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">18. </span><a href="#/chapter018"><span class="toc-item-title-text">Caleb</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">19. </span><a href="#/chapter019"><span class="toc-item-title-text">Thac</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">20. </span><a href="#/chapter020"><span class="toc-item-title-text">Caleb</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">21. </span><a href="#/chapter021"><span class="toc-item-title-text">Mia</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">22. </span><a href="#/chapter022"><span class="toc-item-title-text">Caleb</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">23. </span><a href="#/chapter023"><span class="toc-item-title-text">Mia</span></a></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/othervalkyriesrisingbooks"><span class="toc-item-title-text">Other Valkyries Rising Books</span></a></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?cfabf6e0